module.exports = __webpack_public_path__ + "static/media/badge-Google.9967eb15.svg";